import Cargar_facturas from "../../../components/ingreso_facturas/ingreso_facturas.vue";
import CryptoJS from "crypto-js";

export default {
  components: {
    Cargar_facturas,
  },
  data() {
    return {
      cargarFacturasRetenciones: false,
      usuario: -1,
      loading: false,
      presentaciones: [],
      search: "",
      item_aux: "",
      tab: null,
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui",
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Fecha Nac.",
          align: "center",
          sortable: true,
          value: "usuario_fecha_nacimiento",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Contraseña agencia Virtual",
          align: "center",
          sortable: false,
          value: "password_sat",
        },
        {
          text: "Dia de declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion",
        },
        {
          text: "Estado Facturas",
          align: "center",
          sortable: true,
          value: "facturas",
        },
        {
          text: "Estado Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones",
        },
        {
          text: "# de Registro de Colaborador TIC",
          align: "center",
          sortable: true,
          value: "asignado_id",
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      data_fecha: {
        fecha_usuario: "",
        fecha: "",
      },
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      data: "",
      dialogEnviarPago: false,
      text: "Copiar",
      copyText: "",
      dialogPresentara0: false,
      numero_formulario: null,
      documento: null,
      documento_aux: null,
      tipoRegimen: [],
      tipo_id: 1,
      tipo_nombre: "Pequeño Contribuyente",
      temp_table: false,
      isISR: false,
    };
  },
  watch: {
    numero_formulario() {
      console.log('numero_formulario');
      this.numero_formulario = this.numero_formulario.trim();
    },

    async documento(value) {
      console.log('documento');
      if (value === null || this.documento === null) {
        return;
      }
      try {
        let fr = new FileReader();
        fr.addEventListener("load", async (e) => {
          //this is your base64
          this.documento_aux = e.target.result;
          this.loading = false;
        });

        fr.readAsDataURL(value);
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
  computed: {
    size() {
      console.log('size');
      const size = { xs: "x-small", sm: "small", md: "small", lg: "small" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
  async created() {
    console.log("reporte_ingreso.0");
    await this.getRegimenListado();
    // await this.getListaodDeclaracionesIngreso();

    let informacion_incriptada = sessionStorage.getItem(
      "dsgfv/&#$%sdksdn..sd5454sd-todo"
    );
    if (informacion_incriptada != null) {
      let key_pass = atob(
        sessionStorage.getItem("dsgfv/&#$%sdksdn..sd5454sd-tic")
      );
      let bytes = CryptoJS.AES.decrypt(
        informacion_incriptada,
        key_pass + "byTeamT0d0T1c"
      );
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      let r = JSON.parse(informacion_desincriptada);
      this.usuario = r.usuario[0];
      // console.log('hack_user', this.usuario);
    }
  },
  methods: {
    async getRegimenListado() {
      console.log('getRegimenListado');
      try {
        this.loading_regimenes = true;
        let r =
          await this.$store.state.services.administradorService.getRegimenListado();
        this.tipoRegimen = r.data.data;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen");
      }
    },
    async filtarInformacion(id, descripcion) {
      this.cargarFacturasRetenciones = false;
      this.isISR = false;
      if (id == 2) {
        this.isISR = true;
      }
      console.log('filtarInformacion');
      this.temp_table = true;
      this.tipo_id = id;
      this.tipo_nombre = descripcion;
      await this.getListaodDeclaracionesIngreso();
    },
    presentar0(item) {
      console.log('presentar0');
      this.dialogPresentara0 = true;
      this.item_aux = item;
    },
    reset() {
      console.log('reset');
      this.copyText = this.text;
    },
    async copyCode(item) {
      console.log('copyCode');
      await navigator.clipboard.writeText(item);
      this.copyText = "Copiado";
    },
    regresar(data) {
      console.log('regresar');
      this.cargarFacturasRetenciones = false;
      this.data = "";
      this.date = data.fecha;
      this.presentaciones = [];
      this.getListaodDeclaracionesIngreso();
    },
    cargarDocumentos(item) {
      console.log('cargarDocumentos:', item);
      try {
        item.fecha = this.date;
        this.data = item;
        console.log('this.data', this.data);
        this.data.carga = false;
        this.cargarFacturasRetenciones = true;
      } catch (error) {
        this.$toast.error("No es posible el ingreso de facturas");
      }
      // if (this.isISR == true) {
      //   try {
      //     item.fecha = this.date;
      //     this.data = item;
      //     this.data.carga = false;
      //     this.cargarFacturasRetenciones = true;
      //   } catch (error) {
      //     this.$toast.error("No es posible el ingreso de facturas");
      //   }
      // } else {
      //   console.log('hacer lo que se tiene que hacer');
      // }
    },
    async declararsinISR(item) {
      console.log('declararsinISR:', item);
      console.log('item.usuario_id',item.usuario_id);
      console.log('this.data_fecha',this.data_fecha);

      try{
        let r = await this.$store.state.services.presentacionService.getPresentarSinIRS(item.usuario_id,this.data_fecha.fecha);
        this.$toast.success("Listo");
        window.location.reload();
      }catch (error) {
        console.log(error);
        this.$toast.error("No es posible Presentar");
      }

      
    },
    async enviarSinRetenciones(item) {
      console.log('enviarSinRetenciones');
      this.dialogEnviarPago = true;
      this.item_aux = item;
    },
    async confirmar_enviarSinRenteciones() {
      console.log('confirmar_enviarSinRenteciones');
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.forzarEnvio({
            id: this.item_aux.usuario_id,
          });
        if (r.data.success) {
          this.$toast.success("Traslado de presentación extiosamente");
          this.loading = false;
          this.presentaciones = [];
          this.data = "";
          this.dialogEnviarPago = false;
          this.item_aux = "";
          this.documento = null;
          this.numero_formulario = null;
          this.getListaodDeclaracionesIngreso();
        } else {
          this.$toast.error("No es posible trasladar a pago");
          this.loading = false;
          this.dialogEnviarPago = false;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible trasladar a pago");
        this.loading = false;
        this.dialogEnviarPago = false;
      }
    },
    async confirmar_enviarSinFacturasYRetenciones() {
      console.log('confirmar_enviarSinFacturasYRetenciones');
      if (this.$refs.form.validate()) {
        this.data_fecha.fecha_usuario = this.date
          .split("-")
          .reverse()
          .join("/");
        this.data_fecha.fecha = this.date;
        try {
          this.loading = true;
          let r =
            await this.$store.state.services.presentacionService.forzarEnvioA0({
              aplica_sub: true,
              id: this.item_aux.usuario_id,
              fecha: this.data_fecha.fecha,
              numero_formulario: this.numero_formulario,
              documento: this.documento_aux,
            });
          if (r.data.success) {
            this.$toast.success("Traslado de presentación extiosamente");
            this.loading = false;
            this.presentaciones = [];
            this.data = "";
            this.dialogPresentara0 = false;
            this.item_aux = "";
            this.documento = null;
            this.numero_formulario = null;
            this.documento_aux = null;
            this.getListaodDeclaracionesIngreso();
          } else {
            this.$toast.error("No es posible trasladar a pago");
            this.loading = false;
            this.dialogPresentara0 = false;
            this.documento = null;
            this.documento_aux = null;
            this.numero_formulario = null;
          }
        } catch (error) {
          this.$toast.error("No es posible trasladar a pago");
          this.loading = false;
          this.dialogPresentara0 = false;
        }
      }
    },
    allowedDates: (date) =>
      date <=
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    async getListaodDeclaracionesIngreso() {
      console.log('getListaodDeclaracionesIngreso');
      this.presentaciones = [];
      this.data_fecha.fecha_usuario = this.date.split("-").reverse().join("/");
      this.data_fecha.fecha = this.date;
      this.data_fecha.regimen_id = this.tipo_id;
      console.log('this.data_fecha', this.data_fecha);
      try {
        this.loading = true;
        let r = await this.$store.state.services.presentacionService.getListaodDeclaracionesIngreso(this.data_fecha);
        this.loading = false;
        this.presentaciones = r.data.data;
        console.log('this.presentaciones', this.presentaciones);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error("Ocurrió un error al obtener los del día");
      }
    },
    formatDate(dateString) {
      // Función para formatear la fecha a "día, mes, año"
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('es-ES', options);
    },
  },
  async mounted() {
    console.log("/ingreso_facturas_");
  },
};
